import { FC } from 'react'
import styled from 'styled-components'
import { Box } from '@/components/atoms/Grid'
import RemoveIcon from '@/components/atoms/svg/RemoveIcon'

type RemoveButtonProps = {
  size?: number
  onClick: () => void
} & Rest

const RemoveButton: FC<RemoveButtonProps> = ({
  size = 35,
  onClick,
  ...rest
}) => (
  <Wrapper size={size} onClick={onClick} {...rest}>
    <RemoveIcon width={35} height={35} />
  </Wrapper>
)

export default RemoveButton

const Wrapper = styled<RemoveButtonProps>(Box)`
  display: grid;
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  border-radius: ${(props) => props.size / 2}px;
  &:hover {
    opacity: 0.8;
  }
`
